var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167795",
    "data-name": "Group 167795",
    transform: "translate(-18 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167734",
    "data-name": "Group 167734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2054",
    "data-name": "Ellipse 2054",
    transform: "translate(18 12)",
    fill: "#fff8ea",
    stroke: "#f3b841",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_167738",
    "data-name": "Group 167738",
    transform: "translate(20.057 11.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167737",
    "data-name": "Group 167737",
    transform: "translate(1 4.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49850",
    "data-name": "Path 49850",
    d: "M1.544,9.34,1,5.826a.293.293,0,0,1,.466-.279L3.154,6.81a.4.4,0,0,0,.576-.1l1.4-2.1a.374.374,0,0,1,.623,0l1.4,2.1a.4.4,0,0,0,.576.1L9.418,5.547a.293.293,0,0,1,.466.279L9.343,9.34Zm7.393,1.95H1.951a.407.407,0,0,1-.407-.407V9.99h7.8v.893A.407.407,0,0,1,8.937,11.29Z",
    transform: "translate(-1 -4.441)",
    fill: "#ffb743"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCrown);
export default __webpack_public_path__ + "static/media/GoldCrown.76060b2b2527fc88dc9d403f98dc202d.svg";
export { ForwardRef as ReactComponent };